import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

// import { PhnxFormtoggle } from './Formtoggle'
// import { FormtoggleProps } from './Formtoggle'

interface FormtoggleBlokProps {
  blok: {
    // title: FormtoggleProps['title']
  } & SbBlokData
}

const Formtoggle: FC<FormtoggleBlokProps> = ({ blok }) => {
  return <div {...storyblokEditable(blok)}>{/* <PhnxFormtoggle title={blok.title} /> */}</div>
}

export default Formtoggle
